














































import { Component, Vue } from 'vue-property-decorator';
import CourseList from '../Course/List.vue';
import { BookService, BookViewModel } from '../../api/book';
import { CourseViewModel } from '../../api/course';
import { PagedList } from '../../api/PagedList';
import global from '../../utils/global';
@Component({
  components: {
    CourseList,
  },
})
export default class BookIndex extends Vue {
  private courseId: number = 0;
  private courseData: CourseViewModel = {};
  private bookService: BookService = new BookService();
  private data: PagedList<BookViewModel> = new PagedList<BookViewModel>();
  private condition: BookViewModel = this.bookService.NewModel;
  private pageIndex: number = 1;
  private imgUrl: string = `${global.BACKGROUND_URL}\\book\\`;
  private created() {
    this.courseId = parseInt(this.$route.query.id === undefined ? '0' : (this.$route.query.id + ''));
  }
  private course_OnChange(course: any) {
    this.courseData = course;
    this.search(1);
  }
  private search(page: number) {
    this.pageIndex = page;
    this.bookService.Search({courseID: this.courseData.id}, page).then((response: any) => {
      this.data = response;
    });
  }

  private page_OnChange(page: number) {
    this.search(page);
  }
  private btnBookListItem_OnClick(item: BookViewModel) {
    this.$router.push({name: 'file', query: {id: item.guid!.toString()}});
  }
}
